import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslationService } from '@sdbn/common';
import { FilterAdministrationContext } from '../../../../filter-administration.context';
import { FilterCondition } from '../../../../filter-administration.model';
import { FilterDetailsComponent } from '../../../../filter-details-component.model';

@Component({
  selector: 'app-empty-node-editor',
  templateUrl: './empty-node-editor.component.html',
  styleUrls: ['./empty-node-editor.component.scss']
})
export class EmptyNodeEditorComponent implements OnInit, OnDestroy, FilterDetailsComponent {

  condition: FilterCondition;

  filterAdministrationContext: FilterAdministrationContext;
  filterAdministrationContextSubscription: Subscription;


  constructor(
    public translationService: TranslationService
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.filterAdministrationContextSubscription != null) {
      this.filterAdministrationContextSubscription.unsubscribe();
    }
  }

  setFilterAdministrationContext(filterAdministrationContext: FilterAdministrationContext) {
    this.filterAdministrationContext = filterAdministrationContext;
    this.condition = this.filterAdministrationContext.getSelectedFilterCondition();

    this.filterAdministrationContextSubscription = this.filterAdministrationContext.contextChange$.subscribe(
      change => {
        try {
          if (change.key === 'selected-filter-condition-changed') {
            this.condition = this.filterAdministrationContext.getSelectedFilterCondition();
          }
        } catch (error) {
          console.log(error);
        }
      }
    );
  }

}
